import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

interface Props {
  // ダイアログを表示するかどうか
  display: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QuotationConfirmDialog',
  props: {
    display: { type: Boolean }
  },
  emits: ["ok", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const dialog = computed(() => props.display);

const emit = __emit;

const ok = () => {
  emit('ok');
};

const cancel = () => {
  emit('cancel');
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    persistent: "",
    class: "order-quotation-dialog quotation-confirm-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "information" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_avatar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, { name: "mdi-alert-circle" })
                ]),
                _: 1
              }),
              _createVNode(_component_q_toolbar_title, { class: "text-weight-bold" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("お問い合わせ確認")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("span", { style: {"font-size":"16px"} }, "注意事項", -1),
              _createElementVNode("ul", { class: "dialog-textarea" }, [
                _createElementVNode("li", null, "お問い合わせ内容は確定メールにてご確認ください")
              ], -1),
              _createElementVNode("p", {
                class: "q-mb-sm",
                style: {"margin-left":"21px"}
              }, " ※法規制化学物質チェックを行うので処理に時間がかかる可能性があります。 ", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "btn-area q-gutter-md"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "問い合わせ依頼を確定する",
                style: {"width":"200px"},
                onClick: ok
              }),
              _createVNode(_component_q_btn, {
                outline: "",
                label: "キャンセル",
                style: {"color":"var(--q-delete)","width":"180px"},
                onClick: cancel
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})